<template>
  <div>
    <div v-if="loaded">
      <ClockPlan v-if="planData" :data="planData" />
      <PlanList v-else />
      <van-popup v-model="showInit" :overlay="false" class="init-popup">
        <InitClock v-if="showInit" @end="bindEndInit" />
      </van-popup>
      <ActivityToast />
    </div>
    <AppLoading v-else class="loading" />
  </div>
</template>
<script>
import AppLoading from '@/components/app/loading/loading.vue'
import PlanList from './components/plan-list.vue'
import ClockPlan from './components/clock-plan.vue'
import InitClock from './components/init-clock.vue'
import ActivityToast from './components/activity-toast.vue'
export default {
  components: {
    PlanList,
    ClockPlan,
    InitClock,
    AppLoading,
    ActivityToast
  },
  data() {
    return {
      loaded: false,
      options: {},
      planData: null,
      showInit: false
    }
  },
  created() {
    this.getIsInit()
  },
  methods: {
    bindEndInit() {
      this.showInit = false
    },
    async getIsInit() {
      let params = {}
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/firstOpen', params)
        .catch(() => {})
      this.getPlanData()
      if (res) {
        res = res.data
        if (res.code == 200) {
          // this.showInit = !!res.data.is_first;
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindBack() {},
    /* 获取计划详情数据 */
    async getPlanData() {
      let params = {}
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/tonicPlanShowDetail', params)
        .catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data && !Array.isArray(res.data)) {
            /* 添加服务器时间 */
            // res.time = 1706803195;
            res.data.serverTime = +res.time
            this.planData = res.data
          }
        } else {
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.init-popup {
  background-color: transparent;
}
.loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
